import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Field, reduxForm, change, formValueSelector } from "redux-form";
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Button,
  Input,
  Label,
  Form,
  FormGroup,
  Alert,
  FormFeedback,
} from "reactstrap";
import {
  validationHelper,
  formatHelper,
  normalizeHelper,
} from "../../../../common/helpers";
import { messages } from "../../../../common/constants";
import { toast } from "react-toastify";
import {
  getProduct,
  updateProduct,
  resetProduct,
  resetUpdateProduct,
} from "../../../../store/product/actions";
import { selectUserRole } from "../../../../store/user/selector";
import { roles } from "../../../../common/constants";
import { getCategories } from "../../../../store/category/actions";
import { getProviders } from "../../../../store/provider/actions";
import { getIGV } from "../../../../store/sell/actions";
import { MainLoader, ClosableImage } from "../../../../components";
import { FilePond, registerPlugin } from "react-filepond";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
registerPlugin(FilePondPluginImagePreview, FilePondPluginFileValidateType);

class ProductEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imgV: null,
      imgH: null,
      rmImgV: false,
      rmImgH: false,
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.renderCategoriesField = this.renderCategoriesField.bind(this);
    this.renderProvidersField = this.renderProvidersField.bind(this);
    this.renderClosableImg = this.renderClosableImg.bind(this);
    this.renderInputImg = this.renderInputImg.bind(this);
  }

  async componentDidMount() {
    await this.props.getCategories({ reset: true });
    await this.props.getProviders({ reset: true });
    await this.props.getIGV();
    await this.props.getProduct(this.props.match.params.id);
  }

  componentDidUpdate(prevProps) {
    this.checkDiscountChange(prevProps);
    this.checkProductUpdate(prevProps);
  }

  checkProductUpdate(prevProps) {
    if (prevProps.updatedProduct == null && this.props.updatedProduct != null) {
      toast.success("Producto actualizado satisfactoriamente");
      this.props.history.push("/administration/products");
    }
  }

  checkDiscountChange(prevProps) {
    if (
      (prevProps.discountValue != this.props.discountValue &&
        this.props.discountValue != null) ||
      (prevProps.priceValue != this.props.priceValue &&
        this.props.priceValue != null)
    ) {
      const { discountValue, priceValue } = this.props;
      if (!discountValue || !priceValue) return;
      let priceDiscount = formatHelper.toTwoDecimal(
        (priceValue * (100 - discountValue)) / 100
      );
      this.props.changeValueForm(
        "ProductEditForm",
        "price_discount",
        priceDiscount
      );
    }
    if (
      (prevProps.priceDiscountCorporativeValue !=
        this.props.priceDiscountCorporativeValue &&
        this.props.priceDiscountCorporativeValue != null) ||
      (prevProps.priceValue != this.props.priceValue && this.props.priceValue)
    ) {
      const { priceDiscountCorporativeValue, priceValue } = this.props;
      if (!priceDiscountCorporativeValue || !priceValue) return;
      let discountCorporative = formatHelper.toTwoDecimal(
        ((priceValue - priceDiscountCorporativeValue) / priceValue) * 100
      );

      this.props.changeValueForm(
        "ProductEditForm",
        "discount_corporative",
        discountCorporative
      );
    }
  }

  componentWillUnmount() {
    this.props.resetProduct();
    this.props.resetUpdateProduct();
  }

  onSubmit(values) {
    if (values.category_id == "0") delete values.category_id;
    if (values.discount && !isNaN(Number(values.discount)))
      values.discount = values.discount / 100;
    else {
      delete values.discount;
      delete values.price_discount;
    }

    if (
      values.discount_corporative &&
      !isNaN(Number(values.discount_corporative))
    )
      values.discount_corporative = values.discount_corporative / 100;
    else {
      delete values.discount_corporative;
      delete values.price_discount_corporative;
    }

    if (!values.app_points) delete values.app_points;

    if (!values.cost || isNaN(Number(values.cost))) delete values.cost;

    values.rmImgH = this.state.rmImgH;
    values.rmImgV = this.state.rmImgV;
    this.props.updateProduct(
      this.props.match.params.id,
      values,
      this.state.imgV,
      this.state.imgH
    );
  }

  renderClosableImg(verticalImg) {
    return (
      <FormGroup row>
        <Col md="2" lg="1">
          <Label>
            {verticalImg
              ? "Imagen Vertical (900x1280):"
              : "Imagen Horizontal (1200x700):"}
          </Label>
        </Col>
        <Col xs="12" md="5">
          <ClosableImage
            src={
              verticalImg
                ? this.props.initialValues.app_img
                : this.props.initialValues.app_img_flat
            }
            onClose={(e) => {
              e.preventDefault();
              if (verticalImg) {
                this.setState({ rmImgV: true });
                this.setState({ imgV: null });
              } else {
                this.setState({ rmImgH: true });
                this.setState({ imgH: null });
              }
            }}
          />
        </Col>
      </FormGroup>
    );
  }

  renderInputImg(verticalImg) {
    return (
      <FormGroup row>
        <Col md="2" lg="1">
          <Label>
            {verticalImg
              ? "Imagen Vertical (900x1280):"
              : "Imagen Horizontal (1200x700):"}
          </Label>
        </Col>
        <Col xs="12" md="5">
          <FilePond
            labelIdle='Arrastra y Suelta una foto o <span class="filepond--label-action"> Elige </span>'
            acceptedFileTypes="image/jpeg, image/png"
            labelFileTypeNotAllowed="Archivo no válido"
            onupdatefiles={(fileItems) => {
              if (fileItems.length == 0) return;
              verticalImg
                ? this.setState({ imgV: fileItems[0].file })
                : this.setState({ imgH: fileItems[0].file });
            }}
            onremovefile={(file) => {
              verticalImg
                ? this.setState({ imgV: null })
                : this.setState({ imgH: null });
            }}
          />
        </Col>
      </FormGroup>
    );
  }

  renderInputField(field) {
    const {
      meta: { touched, error },
    } = field;
    const hasError = touched && error ? true : false;
    const labelClass = field.labelClass ? field.labelClass : "mt-1";

    return (
      <FormGroup row>
        <Col md="2" lg="1">
          <Label className={labelClass}>{field.label}</Label>
        </Col>
        <Col xs="12" md="5">
          <Input {...field.input} invalid={hasError} type={field.type} />
          {hasError == true ? <FormFeedback>{error}</FormFeedback> : null}
        </Col>
      </FormGroup>
    );
  }

  renderStaticField(field) {
    const {
      meta: { touched, error },
    } = field;
    const hasError = touched && error ? true : false;
    const labelClass = field.labelClass ? field.labelClass : "mt-1";

    return (
      <FormGroup row>
        <Col md="2" lg="1">
          <Label className={labelClass}>{field.label}</Label>
        </Col>
        <Col xs="12" md="5">
          <Input
            {...field.input}
            invalid={hasError}
            type={field.type}
            readOnly
          />
        </Col>
      </FormGroup>
    );
  }

  renderPriceWithoutTax() {
    const { priceValue, igv } = this.props;
    let value = "";
    if (igv)
      value =
        priceValue != null
          ? formatHelper.toTwoDecimal(priceValue / (1 + 0.18))
          : "";

    return (
      <FormGroup row>
        <Col md="2" lg="1">
          <Label>Precio sin IGV (S/):</Label>
        </Col>
        <Col xs="12" md="5">
          <Label>{value}</Label>
        </Col>
      </FormGroup>
    );
  }

  renderCategoryItems() {
    return this.props.categories.map((category) => {
      return (
        <option key={category.id} value={category.id}>
          {category.name}
        </option>
      );
    });
  }

  renderCategoriesField(field) {
    const {
      meta: { touched, error },
    } = field;
    const hasError = touched && error ? true : false;

    return (
      <FormGroup row>
        <Col md="2" lg="1">
          <Label htmlFor="select">Categoría *:</Label>
        </Col>
        <Col xs="12" md="5">
          <Input {...field.input} type="select" invalid={hasError}>
            <option key={0} value={0}>
              Seleccione...
            </option>
            {this.renderCategoryItems()}
          </Input>
          {hasError == true ? <FormFeedback>{error}</FormFeedback> : null}
        </Col>
      </FormGroup>
    );
  }

  renderProviderItems() {
    return this.props.providers.map((provider) => {
      return (
        <option key={provider.id} value={provider.id}>
          {provider.name}
        </option>
      );
    });
  }

  renderProvidersField(field) {
    const {
      meta: { touched, error },
    } = field;
    const hasError = touched && error ? true : false;

    return (
      <FormGroup row>
        <Col md="2" lg="1">
          <Label htmlFor="select">Proveedor *:</Label>
        </Col>
        <Col xs="12" md="5">
          <Input {...field.input} type="select" invalid={hasError}>
            <option key={0} value={0}>
              Seleccione...
            </option>
            {this.renderProviderItems()}
          </Input>
          {hasError == true ? <FormFeedback>{error}</FormFeedback> : null}
        </Col>
      </FormGroup>
    );
  }

  render() {
    const {
      handleSubmit,
      error,
      loading,
      updatedLoading,
      updatedError,
      loadingCategories,
      providersLoading,
      igvLoading,
      role,
    } = this.props;
    const isLoadingFetch =
      loading || providersLoading || loadingCategories || igvLoading;

    if (error) {
      return <Alert color="danger">{error}</Alert>;
    }
    if (isLoadingFetch) {
      return <MainLoader />;
    }
    return (
      <div className="animated">
        <Card>
          <CardHeader>Editar Producto</CardHeader>
          <CardBody>
            {updatedError && <Alert color="danger">{updatedError}</Alert>}
            <Form onSubmit={handleSubmit(handleSubmit(this.onSubmit))}>
              <Field
                name="name"
                label="Nombre *:"
                type="text"
                component={this.renderInputField}
              />
              <Field
                name="code"
                label="Código:"
                type="text"
                component={this.renderInputField}
              />
              <Field
                name="price"
                label="Precio (S/) *:"
                type="text"
                component={this.renderInputField}
                normalize={normalizeHelper.decimalOnlyField()}
              />
              {this.renderPriceWithoutTax()}
              <Field
                name="cost"
                label="Costo (S/):"
                type="text"
                component={this.renderInputField}
                normalize={normalizeHelper.decimalOnlyField()}
              />
              <Field
                name="discount"
                label="Descuento (%):"
                type="text"
                component={this.renderInputField}
                normalize={normalizeHelper.decimalOnlyField(0, 100)}
              />
              <Field
                name="price_discount"
                label="Precio con Descuento (S/):"
                type="text"
                component={this.renderStaticField}
              />
              <Field
                name="discount_corporative"
                label="Descuento Corporativo (%):"
                type="text"
                component={this.renderStaticField}
                normalize={normalizeHelper.decimalOnlyField(0, 100)}
              />
              <Field
                name="price_discount_corporative"
                label="Precio Con Descuento Corporativo (S/):"
                type="text"
                component={this.renderInputField}
              />
              {role == roles.SUPER_ADMIN && (
                <React.Fragment>
                  <Field
                    name="app_name"
                    label="Nombre en aplicación móvil:"
                    type="text"
                    component={this.renderInputField}
                  />
                  <Field
                    name="app_points"
                    label="Puntos en aplicación móvil:"
                    type="text"
                    component={this.renderInputField}
                    normalize={normalizeHelper.numberOnlyField()}
                  />
                </React.Fragment>
              )}
              {this.props.initialValues &&
              this.props.initialValues.app_img &&
              !this.state.rmImgV
                ? this.renderClosableImg(true)
                : this.renderInputImg(true)}
              {this.props.initialValues &&
              this.props.initialValues.app_img_flat &&
              !this.state.rmImgH
                ? this.renderClosableImg(false)
                : this.renderInputImg(false)}
              <Field
                name="category_id"
                component={this.renderCategoriesField}
              />
              <Field name="provider_id" component={this.renderProvidersField} />
              <Row>
                <Col className="mt-3">
                  <Button
                    type="submit"
                    disabled={updatedLoading}
                    color="primary"
                    className="mr-2"
                  >
                    <i className="fa fa-save mr-1" /> Guardar
                  </Button>
                  <Button
                    color="secondary"
                    onClick={() =>
                      this.props.history.push("/administration/products")
                    }
                  >
                    <i className="fa fa-chevron-left mr-1" /> Cancelar
                  </Button>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>
      </div>
    );
  }
}

function validate(values) {
  const errors = {};

  if (validationHelper.stringIsNullOrEmpty(values.name)) {
    errors.name = messages.MANDATORY_FIELD;
  }

  if (validationHelper.stringIsNullOrEmpty(values.price)) {
    errors.price = messages.MANDATORY_FIELD;
  } else if (!validationHelper.isMoney(values.price)) {
    errors.price = messages.DECIMAL_FORMAT_FIELD;
  }

  if (
    !validationHelper.isMoney(values.cost) &&
    !validationHelper.stringIsNullOrEmpty(values.cost)
  ) {
    errors.cost = messages.DECIMAL_FORMAT_FIELD;
  }

  if (
    validationHelper.stringIsNullOrEmpty(values.category_id) ||
    values.category_id == "0"
  ) {
    errors.category_id = messages.MANDATORY_FIELD;
  }

  if (
    validationHelper.stringIsNullOrEmpty(values.provider_id) ||
    values.provider_id == "0"
  ) {
    errors.provider_id = messages.MANDATORY_FIELD;
  }

  return errors;
}

const formSelector = formValueSelector("ProductEditForm");

function mapStateToProps(state) {
  const { product, error, loading } = state.product.activeProduct;
  const { activeIGV } = state.sell;
  const { providerList } = state.provider;
  const { categoryList } = state.category;

  return {
    initialValues: product,
    loading,
    error,
    updatedProduct: state.product.updateProduct.product,
    updatedError: state.product.updateProduct.error,
    updatedLoading: state.product.updateProduct.loading,
    categories: categoryList.categories,
    loadingCategories: categoryList.loading,
    providers: providerList.providers,
    providersLoading: providerList.loading,
    priceValue: formSelector(state, "price"),
    discountValue: formSelector(state, "discount"),
    discountCorporativeValue: formSelector(state, "discount_corporative"),
    priceDiscountCorporativeValue: formSelector(
      state,
      "price_discount_corporative"
    ),
    igv: activeIGV.igv,
    igvLoading: activeIGV.loading,
    role: selectUserRole(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getProduct,
      updateProduct,
      getCategories,
      getProviders,
      resetProduct,
      resetUpdateProduct,
      getIGV,
      changeValueForm: change,
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: "ProductEditForm",
    touchOnBlur: false,
    keepDirtyOnReinitialize: true,
    enableReinitialize: true,
    validate,
  })(ProductEdit)
);



// WEBPACK FOOTER //
// ./src/scenes/Administration/Product/ProductEdit/ProductEdit.js